var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 9.55566 8.98926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 8.98926,
    opacity: 0,
    width: 9.55566,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5332 8.98926L7.45605 8.98926C8.48145 8.98926 8.98926 8.48633 8.98926 7.48047L8.98926 1.51367C8.98926 0.507812 8.48145 0 7.45605 0L1.5332 0C0.512695 0 0 0.507812 0 1.51367L0 7.48047C0 8.48633 0.512695 8.98926 1.5332 8.98926ZM1.54297 8.20312C1.05469 8.20312 0.786133 7.94434 0.786133 7.43652L0.786133 1.55762C0.786133 1.0498 1.05469 0.786133 1.54297 0.786133L7.44629 0.786133C7.92969 0.786133 8.20312 1.0498 8.20312 1.55762L8.20312 7.43652C8.20312 7.94434 7.92969 8.20312 7.44629 8.20312Z",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02539 5.70312C6.24023 5.70312 6.38672 5.53711 6.38672 5.3125L6.38672 3.00781C6.38672 2.71973 6.22559 2.60742 5.97656 2.60742L3.66211 2.60742C3.43262 2.60742 3.28613 2.74902 3.28613 2.96387C3.28613 3.17871 3.4375 3.32031 3.67188 3.32031L4.56055 3.32031L5.2832 3.24219L4.52148 3.9502L2.71973 5.75195C2.65137 5.82031 2.60742 5.91797 2.60742 6.01562C2.60742 6.23535 2.74902 6.37695 2.96387 6.37695C3.08105 6.37695 3.17383 6.33301 3.24219 6.26465L5.03906 4.46777L5.74219 3.71582L5.66895 4.47754L5.66895 5.32227C5.66895 5.55176 5.81055 5.70312 6.02539 5.70312Z",
    fill: "white",
    fillOpacity: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.783e699d84d5fab571e7e0e4841d9bd3.svg";
export { ForwardRef as ReactComponent };